import React, { memo } from 'react';

import { Flex } from '@adsk/alloy-react-box';
import { IconButton } from '@adsk/alloy-react-button';
import { XIcon } from '@adsk/alloy-react-icon';
import { OverflowTooltip } from '@adsk/alloy-react-tooltip';

import { Announcement, useAnnouncement } from '../../hooks/useAnnouncment';
import FlexCentered from '../FlexCentered';

export const AnnouncementBanner = memo((props: Announcement) => {
  const { visible, onDismiss, announcementText, allowDismiss } =
    useAnnouncement(props);

  if (!visible) {
    return null;
  }

  return (
    <FlexCentered
      padding="0 24px"
      data-testid="announcement-banner-wrapper"
      backgroundColor="yellowOrange100"
      height="32px"
      alignContent="center"
    >
      <Flex flex={1}>
        <OverflowTooltip
          triggerTarget={OverflowTooltip.TRIGGER_TARGETS.TOOLTIP}
          getTargetProps={() => ({
            style: { width: '100%', textAlign: 'center' },
          })}
        >
          {announcementText}
        </OverflowTooltip>
      </Flex>
      {allowDismiss && (
        <Flex>
          <IconButton
            onClick={onDismiss}
            data-testid="announcement-banner-dismiss"
          >
            <XIcon size={16} />
          </IconButton>
        </Flex>
      )}
    </FlexCentered>
  );
});

AnnouncementBanner.displayName = 'AnnouncementBanner';
